export enum UserAttendanceStatus {
   'Online' = 'Online',
   'Offline' = 'Offline'
}
